// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__7X-wT","sk-bouncedelay":"style_sk-bouncedelay__2HVSP","bounce1":"style_bounce1__QOgd0","bounce2":"style_bounce2__37HRg"};